/**
 * Template: Blog.Masonry
 * -----------------------------------------------------------------------------
 * Styles for blog.masonry template.
 *
 */

import '@/templates/blog-masonry.scss'

/**
 * Components.
 */
import BlogFilters from '~/components/blog-filters'
import InlineProduct from '~/components/inline-product'
import ArticleShare from '~/components/article-share'

document.addEventListener('DOMContentLoaded', () => {
  BlogFilters().init()
  InlineProduct().init()
  ArticleShare().init()
})
